import { hydrateRoot } from 'react-dom';
import { Globals } from '@bwoty-web/ui-kit';
import PackagePlusInfoView from '../shared/views/packagePlus/PackagePlusInfoView';

const initialStateGeoPackagePlusInfo =
  window.__INITIAL_STATE_GEO_PACKAGE_PLUS_INFO__;
delete window.__INITIAL_STATE_GEO_PACKAGE_PLUS_INFO__;
const geoPackagePlusInfoRoot = document.getElementById(
  'geo-package-plus-info-view',
);

if (geoPackagePlusInfoRoot) {
  const { attributes, content, legacyMode, price, siteId } =
    initialStateGeoPackagePlusInfo;
  hydrateRoot(
    geoPackagePlusInfoRoot,
    <Globals siteId={siteId} legacyMode={legacyMode}>
      <PackagePlusInfoView
        geoPackagePlusInfo={content}
        labels={attributes}
        price={price}
        siteId={siteId}
      />
    </Globals>,
  );
}
